<template>
    <div class="register-comp">
        <verified-email-has-sent :noClose="true" :email="register.email"></verified-email-has-sent>
        <div class="input-block">
            <label class="button-font landing-input-label">
                <div class="title">
                    <span class="must-fill">*</span>
                    電子郵件帳號
                </div>
                <span v-show="error.register.email" class="error-with-title">{{error.register.email}}</span>
            </label>
            <div class="input-arear">
                <input class="landing-input" :class="{error: error.register.email}" type="text" v-model="register.email" placeholder="請輸入電子郵件帳號">
            </div>
        </div>
        <div class="input-block password">
            <label class="button-font landing-input-label">
                <div class="title">
                    <span class="must-fill">*</span>
                    密碼
                </div>
                <span v-show="error.register.password" class="error-with-title">{{error.register.password}}</span>
            </label>
            <div class="input-arear">
                <input class="landing-input" ref="password" :class="{error: error.register.password}" type=password v-model="register.password" placeholder="需包含英文加上數字八位字元">
                <div v-if="password.pwdShow" @click="togglePassword('pwd')" class="show-hide-pwd">
                    <span v-if="password.pwdVisible">
                        隱藏
                    </span>
                    <span v-else>
                        顯示
                    </span>
                </div>
            </div>
        </div>
        <div class="input-block password-check">
            <label class="button-font landing-input-label">
                <div class="title">
                    <span class="must-fill">*</span>
                    確認密碼
                </div>
                <span v-show="error.register.passwordCheck" class="error-with-title">{{error.register.passwordCheck}}</span>
            </label>
            <div class="input-arear">
                <input class="landing-input"  ref="passwordCheck" :class="{error: error.register.passwordCheck}" type=password v-model="register.passwordCheck" placeholder="再次確認密碼">
                <div v-if="password.pwdCheckShow" @click="togglePassword('pwdCheck')" class="show-hide-pwd">
                    <span v-if="password.pwdCheckVisible">
                        隱藏
                    </span>
                    <span v-else>
                        顯示
                    </span>
                </div>
            </div>
        </div>
        <div class="input-block position">
            <label class="button-font landing-input-label">
                <div class="title">
                    <span class="must-fill">*</span>
                    工作崗位
                </div>
                <span v-show="error.register.position" class="error-with-title">{{error.register.position}}</span>
            </label>
            <div class="input-arear">
                <rent-select class="landing" :class="{error: error.register.position}" refName="position" selectMsg="請選擇工作崗位" @getId="getSelectId"  bgColor="#fff" >
                    <ul>
                        <li v-for="(item, index) in positionList" :key="index" :data-id="index">{{item}}</li>
                    </ul>
                </rent-select>
            </div>
        </div>
        <div class="loading-wrap">
            <btn-loading v-if="status.isDisable"></btn-loading>
            <button class="landing-default-btn" :disabled="status.isDisable" @click="bizRegister()">成為企業會員</button>
        </div>
        <span class="private">註冊即同意  <router-link :to="{ name: 'bizPrivacyPolicy'}">隱私權政策</router-link> | <router-link :to="{ name: 'bizUserTerms'}">會員條款</router-link></span>
    </div>
</template>

<script>
import RentSelect from '@/components/officailPage/widges/input/RentSelect.vue';
import btnLoading from '@/components/bussiness/widges/btnLoading.vue';
import verifiedEmailHasSent from '@/components/officailPage/widges/modals/verifiedEmailHasSent.vue';
import { mapGetters } from 'vuex'
export default {
    data () {
        return {
            register: {
                email: null,
                password: null,
                passwordCheck: null,
                position: null
            },
            error: {
                register: {
                    email: null,
                    password: null,
                    passwordCheck: null,
                    position: null
                }
            },
            password: {
                pwdShow: false,
                pwdVisible: false,
                pwdCheckShow: false,
                pwdCheckVisible: false,
            },
            status: {
                isDisable: false,
            },
            positionList: ['老闆', '技術人員', '營運人員', '業務',],
        }
    },
    watch: {
        register: {
            handler: function (val) {
                // console.log(val)
                // 帳號判斷
                let isMail = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z]+$/;
                if( val.email ){
                    if (!isMail.test(val.email)) {
                        this.error.register.email = '電子郵件格式錯誤';
                    }else {
                        this.error.register.email = null;
                    }
                }
                //密碼判斷
                let isText = /^(?=.*\d)(?=.*[a-zA-Z]).{8,30}$/;
                if( val.password ){
                    this.password.pwdShow = true
                    if (!isText.test(val.password)) {
                        this.error.register.password = '需包含英文加上數字八位字元';
                    }else {
                        this.error.register.password = null;
                    }
                }
                //密碼確認
                if( val.passwordCheck ){
                    this.password.pwdCheckShow = true
                    if(val.passwordCheck == val.password){
                        this.error.register.passwordCheck = null;
                    }else{
                        this.error.register.passwordCheck = '需與填寫密碼相同';
                    }
                }
                //公司統一編號
                // if( val.companyId ){
                //     this.chknum(val.companyId)
                // }
                //公司統一編號
                if( val.position ){
                    this.error.register.position = null;
                }
            },
            deep: true
        },
    },
    methods: {
        getSelectId: function (value) {
            // console.log(value)
            let targetId = event.target.dataset.id
            if ( value.ref == 'position' ){
                this.register.position = this.positionList[targetId]
            }
        },
        togglePassword: function (type) {
            if(type == 'pwd'){
                let password = this.$refs.password;
                if (password.type === "password") {
                    this.password.pwdVisible = true
                    password.type = "text";
                } else {
                    this.password.pwdVisible = false
                    password.type = "password";
                }
            }else{
                let password = this.$refs.passwordCheck;
                if (password.type === "password") {
                    this.password.pwdCheckVisible = true
                    password.type = "text";
                } else {
                    this.password.pwdCheckVisible = false
                    password.type = "password";
                }
            }
            
        },
        checkInput: function () {

            if(!this.register.email){
                this.error.register.email = '請輸入電子郵件帳號'
            }
            if(!this.register.password){
                this.error.register.password = '請輸入密碼'
            }
            if(!this.register.passwordCheck){
                this.error.register.passwordCheck = '請輸入確認密碼'
            }
            // if(!this.register.companyId){
            //     this.error.register.companyId = '請輸入公司統一編號'
            // }
            if(!this.register.position){
                this.error.register.position = '請選擇工作崗位'
            }
            if(
                this.register.email &&
                this.register.password &&
                this.register.passwordCheck &&
                // this.register.companyId &&
                this.register.position &&
                this.error.register.email == null &&
                this.error.register.password == null &&
                this.error.register.passwordCheck == null &&
                // this.error.register.companyId == null &&
                this.error.register.position == null
            ){
                return true
            }else{
                return false
            }
        },
        bizRegister: function () {
            let email = this.register.email
            let password = this.register.password
            // let companyId = this.register.companyId
            let position = this.register.position

            let data = {
                email,
                password,
                // companyId,
                position
            }

            if(this.checkInput()){
                this.status.isDisable = true
                this.$store.dispatch('bizRegister',data)
                .then(()=>{
                    this.status.isDisable = false
                    this.$store.dispatch('setModalStatus', {state: true, type: 'verifiedEmailHasSent'})
                    // this.$router.push({ name: 'bizVerifiedEmail'})
                })
                .catch(err => {
                    this.status.isDisable = false
                    if(err.data.errorCode == 251011){
                        this.error.register.email = err.data.errorMsg
                    }else{
                        let alarm = {
                            status: true,
                            title: err.data.errorMsg,
                            description: null,
                            type: 'error'
                        }
                        this.$store.dispatch('setAlarmStatus', alarm)
                    }
                })
            }
            
        }
    },
    components: {
        RentSelect,
        btnLoading,
        verifiedEmailHasSent
    }
}
</script>

<style lang="scss" scoped>
    .register-comp{
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        width: 100%;
        .input-block{
            width: 100%;
            margin-bottom: 30px;
        }
        .show-hide-pwd{
            position: absolute;
            font-size: 16px;
            top: 15px;
            right: 16px;
            cursor: pointer;
        }
        .loading-wrap{
            position: relative;
            width: 100%;
            margin-top: 8px;
            margin-bottom: 18px;
            .btn-loading{
                left: 110px;
                top: 7px;
            }
            .landing-default-btn{
                width: 100%;
            }
        }
        .private{
            font-size: 12px;
            color: #676362;
            a{
                color: #676362;
                text-decoration: underline;
                margin: 0 10px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/registerFlow/login/registerComp.vue